import React, { Component } from 'react'
import { Table, Divider, Tag, Button } from 'antd';

// 序号	
// 流程名称	
// 任务摘要	
// 送达时间
export default class NoRepayment extends Component {
  state={
    todoList:[],
    columns: [
      {
        title: '供应商名称',
        dataIndex: 'applorNam',
        key: 'applorNam',
      },
      {
        title: '融资单号',
        dataIndex: 'batchCode',
        key: 'batchCode',
      },
      {
        title: '核心企业名称',
        key: 'purchaserNam',
        dataIndex: 'purchaserNam',
      },
      // {
      //   title: '待还金额',
      //   key: 'toRepayAmt',
      //   dataIndex: 'toRepayAmt',
      // },
      {
        title: '放款金额',
        key: 'factoringAmt',
        dataIndex: 'factoringAmt',
      },
      {
        title: '到期日期',
        key: 'expireDate',
        dataIndex: 'expireDate',
      },
      // {
      //   title: '操作',
      //   key: 'action',
      //   render: (text, record) => (
      //     <Button type="link" size="small" onClick={() => this.todo(record)}>审批</Button>
      //   ),
      // },
    ],

    pagination: {
      total:0, 
      pageSize:10, 
      current:1
    },
  }
  componentDidMount(){
    this.getToDoList()
  }
  todo = (record) => { 
    tool.popUIByUcv(record.uid, {"currentData":record}, record.taskTitle)
  }
  handleTableChange = (pagination, filters, sorter) => { 
    const pager = { ...this.state.pagination }
    pager.current = pagination.current
    pager.pageSize = pagination.pageSize
    this.setState({
      pagination: pager,
    },() => {this.getToDoList()})
  }
  getToDoList = () => { 
    const pendingUrl = sgiConfig.service_finc + '/finc/statistics/fincdetail'; //待办接口
    let req = {
      values: { 
        fincStatus: ["50","70"] 
      },
      batch: true, 
      matchs: { fincStatus: "In" }
    }
    let mockroots = tool.getCookie('qualTyps')
    if(mockroots.includes('03')){
      req.values.applor = tool.getCookie('orgId')
    }else if(mockroots.includes('01')){
      req.values.purchaser = tool.getCookie('orgId')
    }else if(mockroots.includes('02')){
      req.values.purchaser = tool.getCookie('orgId')
    }
    commonClient.simplecall(pendingUrl, req, (res) => { 
      const pagination = { ...this.state.pagination }
      pagination.total = res.head.pageCount
      // this.props.getCount(res.head.pageCount)
      this.setState({
        todoList: res.body,
        pagination
      })
    }, false, null, null, (request) => {
      const {pageSize, current} = this.state.pagination
      request.head.pageSize = pageSize
      request.head.offset = current
    })
  }
  render() {
    let { columns, todoList, pagination } = this.state
    let paginationOps = {
      ...pagination,
      size:"small", 
      showTotal:num => `总数${num}`,
      showSizeChanger:true,
      pageSizeOptions:['10','20','30','40','50','60','70','80','90','100']
    }

    return (
      <Table columns={columns} 
      dataSource={todoList} 
      size="small" 
      pagination={paginationOps} 
      bordered
      onChange={this.handleTableChange}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/workbench/Factor/tablist/NoRepayment.js